const handleSendYandexMetrika = (
  id,
  name,
  alias,
  params,
) => {
  if (typeof window === 'undefined' || !window.ym) return null;
  window.ym(id, name, alias, params);
};

export { handleSendYandexMetrika };
